// Global navigation service that can be used from anywhere
class NavigationService {
  constructor() {
    this.navigate = null;
  }

  setNavigate(navigate) {
    this.navigate = navigate;
  }

  clearNavigate() {
    this.navigate = null;
  }

  navigateTo(path, options = {}) {
    if (this.navigate) {
      this.navigate(path, options);
    } else {
      // Fallback to window.location
      if (typeof window !== 'undefined') {
        if (options.replace) {
          window.location.replace(path);
        } else {
          window.location.href = path;
        }
      }
    }
  }

  replace(path, options = {}) {
    this.navigateTo(path, { replace: true, ...options });
  }

  push(path, options = {}) {
    this.navigateTo(path, { replace: false, ...options });
  }
}

const navigationService = new NavigationService();

export default navigationService;
